import { useQuery } from "@apollo/client";

import { Container, makeStyles } from "@material-ui/core";

import ErrorCard from "src/components/ErrorCard";
import LoadingIndicator from "src/components/LoadingIndicator";
import PageTitle from "src/components/PageTitle";
import { ExportType } from "src/graphql/generated/globalTypes";
import { listTenantExportConfigs } from "src/graphql/generated/listTenantExportConfigs";
import { LIST_TENANT_EXPORT_CONFIGS } from "src/graphql/tenantExportConfigs";

import BigQueryTenantExportConfig from "./BigQueryTenantExportConfig";
import S3TenantExportConfig from "./S3TenantExportConfig";

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(4)
  }
}));

export default function OrgExports(): JSX.Element {
  const classes = useStyles();
  const { loading, error, data } = useQuery<listTenantExportConfigs>(
    LIST_TENANT_EXPORT_CONFIGS
  );

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorCard errors={[error]} />;
  }

  const s3ExportConfig = data?.listTenantExportConfigs?.find(
    config => config.type === ExportType.S3
  );

  const bqExportConfig = data?.listTenantExportConfigs?.find(
    config => config.type === ExportType.BIGQUERY
  );

  return (
    <Container>
      <PageTitle title="Data Exports" />
      <div className={classes.section}>
        <S3TenantExportConfig exportConfig={s3ExportConfig} />
      </div>
      <div className={classes.section}>
        <BigQueryTenantExportConfig exportConfig={bqExportConfig} />
      </div>
    </Container>
  );
}
